<template>
  <div class="footer">
    <div>
      北京量子公因数科技有限公司 ｜
      北京市朝阳区酒仙桥9号院1号楼1层103008室
    </div>
    <div>电话：010-56035934 ｜ 邮箱：wangpu@yuanqisenlin.com</div>
    <div>
      <a
        style="text-decoration: underline"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        rel="noopener noreferrer"
        >{{ sysNo }}</a
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    sysNo() {
      const host = location.host;
      if (host.endsWith("yqslhome.com")) {
        return "京ICP备17027549号-6";
      }
      if (host.endsWith("yqslhome.cn")) {
        return "京ICP备17027549号-5";
      }
      if (host.endsWith("commonfactor.cn")) {
        return "京ICP备2021033362号-1";
      }
      if (host.endsWith("genkimart.cn")) {
        return "京ICP备2021002231号";
      }
      return "京ICP备17027549号-6";
    },
  },
};
</script>
<style lang="scss" scoped>
.footer {
  position: absolute;
  min-width: 1080px;
  width: calc(100% - 80px);
  font-size: 14px;
  font-family: SourceHanSansSC-Medium, SourceHanSansSC;
  font-weight: 500;
  color: #333333;
  line-height: 24px;
  text-align: center;
  // position: fixed;
  bottom: 27px;
  a {
    text-decoration: none;
    color: #333333;
  }
  a:hover {
    text-decoration: underline;
    color: #333333;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue